import { useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import home_logo from '../../assets/icons/ICRI_NEW1.png';
import Auth from '../../auth/auth';
import MockService from '../../Services/MockService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

interface IVerifyEmail {
    email: string
}

export default function VerifyEmail() {
    const state = useLocation().state as IVerifyEmail;
    const email = state?.email || '';
    const navigate = useNavigate();

    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);

    const handleVerify = async () => {
        if (!otp) { toast.error('Please enter the OTP'); return; }
        setLoading(true);
        await MockService.mockEmailVerify(email, otp)
            .then(async (res) => {
                if (res.status === 200) {
                    localStorage.setItem('authKey', res.data?.data?.token || '');
                    Auth.authenticate();
                    toast.success('Verified successfully');
                    navigate('/exam/student-onboarding');
                }
            })
            .catch(() => toast.error('Invalid OTP. Please try again.'))
            .finally(() => setLoading(false));
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') handleVerify();
    };

    return (
        <div className="auth-shell">
            <div style={{ width: '100%', maxWidth: 420 }}>
                <div className="d-flex flex-column align-items-center mb-4">
                    <img src={home_logo} alt="ICRI" style={{ height: 64, marginBottom: 16 }} />

                    <h4 style={{ fontWeight: 700, color: '#1A1A2E', marginBottom: 4 }}>
                        Check your email
                    </h4>

                    <p style={{ color: '#6C757D', fontSize: '0.875rem', margin: 0, textAlign: 'center' }}>
                        We sent a 6-digit code to{" "}
                        <strong style={{ color: '#3B00A8' }}>{email}</strong>
                    </p>

                    <span
                        style={{
                            color: "#6C757D",
                            fontSize: "0.8rem",
                            marginTop: 6,
                            textAlign: "center",
                        }}
                    >
                        Note: Please also check your <strong>Spam / Junk</strong> folder if you don't see the email.
                    </span>
                </div>

                <div className="card-flat">
                    <Form.Group className="mb-4">
                        <Form.Label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#6C757D', letterSpacing: '0.05em', textTransform: 'uppercase' }}>
                            One-Time Password
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="_ _ _ _ _ _"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            onKeyDown={handleKeyDown}
                            maxLength={6}
                            size="lg"
                            style={{ fontSize: '1.25rem', letterSpacing: '0.35em', textAlign: 'center' }}
                        />
                    </Form.Group>

                    <Button
                        variant="primary"
                        size="lg"
                        className="w-100 mb-3"
                        onClick={handleVerify}
                        disabled={loading}
                        style={{ fontWeight: 600 }}
                    >
                        {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
                        {loading ? 'Verifying\u2026' : 'Verify & Continue'}
                    </Button>

                    <button
                        onClick={() => navigate('/login')}
                        style={{ background: 'none', border: 'none', color: '#6C757D', fontSize: '0.825rem', cursor: 'pointer', width: '100%', textAlign: 'center', padding: 0 }}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                        Back to login
                    </button>
                </div>
            </div>
        </div>
    );
}
